// Preserve the side-effect entry point for immediately visible sliders.
import * as flickity from '@theme/flickity';
import {installFlickityFade} from '@theme/flickity-fade-plugin';
installFlickityFade(flickity);
